import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAgency } from '../../api/apiAgencies';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useCreateAgency = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createAgencyMutate,
        isPending,
    } = useMutation({
        mutationFn: createAgency,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agency created successfully');
            navigate('/agencies');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to create agency');
        },
    });

    return {
        createAgencyMutate,
        isPending,
    };
};
